import React, { useState } from "react";
import "../../styles/Faq/faq.css"; // Ensure this path matches your file structure

const FAQSection = () => {
  // State to track which question is currently open (null = all closed)
  const [activeId, setActiveId] = useState(null);

  // Toggle function
  const toggleFAQ = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  // Updated Data based on your image
  const faqData = [
    {
      id: 1,
      question: "Which professional courses does Madhi Academy offer?",
      answer: (
        <>
          We offer specialized coaching for <strong>CA (Chartered Accountancy)</strong>,{" "}
          <strong>CMA (Cost & Management Accountancy)</strong>, and{" "}
          <strong>CS (Company Secretary)</strong> at all levels – Foundation,
          Intermediate/Executive, and Final/Professional.
        </>
      ),
    },
   {
      id: 2,
      question: "Are the classes online or offline?",
      answer: (
        <>
          <p className="mb-2">We provide a blended learning model:</p>
          <ul className="ps-3 mb-0" style={{ listStyleType: 'disc' }}>
            <li className="mb-2">Recorded lectures for flexible study.</li>
            <li className="mb-2">Live doubt-solving sessions for interaction.</li>
            <li>Personal/Small Group tuition for focused guidance.</li>
          </ul>
        </>
      ),
    },
    {
      id: 3,
      question: "Do you provide study materials?",
      answer: "Yes. Students receive printed notes, digital e-books, and revision guides, all aligned with the latest ICAI, ICMAI, and ICSI syllabus.",
    },
    {
      id: 4,
      question: "What is the admission process?",
      answer: (
        <p>
          Contact us via{" "}
          <a
            href="https://www.madhiacademy.com/contact"
            target="_blank"
            rel="noopener noreferrer"
            className="faq-link"
          >
            https://www.madhiacademy.com/contact
          </a>
        </p>
      ),
    },
    {
      id: 5,
      question: "What is the fee structure?",
      answer: "Our fees are affordable and can be paid in installments. Fee details vary by course and level. Please contact our admissions team for the latest structure.",
    },
    {
      id: 6,
      question: "Can I join anytime, or only during admission season?",
      answer: "You can join year-round since we offer recorded classes along with live support. This ensures you never miss out, regardless of exam schedules.",
    },
    {
      id: 7,
      question: "Do you conduct mock exams?",
      answer: "Yes. We have test series and full-length mock exams designed to replicate real exam conditions, ensuring students are fully prepared.",
    },
   {
      id: 8,
      question: "What makes Madhi Academy different from other coaching centers?",
      answer: (
        <ul className="ps-3 mb-0" style={{ listStyleType: 'disc' }}>
          <li className="mb-2">Expert faculty with professional backgrounds.</li>
          <li className="mb-2">Personal mentorship for every student.</li>
          <li className="mb-2">Flexible learning (recorded + live + personal coaching).</li>
          <li>Proven track record of student success.</li>
        </ul>
      ),
    },
   {
      id: 9,
      question: "Who is eligible to join?",
       answer: (
        <p>
          Anyone interested can apply. Please visit{" "}
          <a
            href="https://www.madhiacademy.com/contact"
            target="_blank"
            rel="noopener noreferrer"
            className="faq-link"
          >
            our contact page
          </a>{" "}
          for guidance.
        </p>
      ),
    },
   {
      id: 10,
      question: "How can I get in touch for more details?",
      answer: (
        <ul className="list-unstyled mb-0 ps-1">
          <li className="mb-2 d-flex align-items-center">
            {/* Phone Icon (Pink) */}
            <i className="bi bi-telephone-fill me-2" style={{ color: "#d63384" }}></i>
            Call us: +91 7708941960
          </li>
          <li className="mb-2 d-flex align-items-center">
            {/* Email Icon (Purple) */}
            <i className="bi bi-envelope-fill me-2" style={{ color: "#6f42c1" }}></i>
            Email: admission@madhiacademy.com
          </li>
          <li className="d-flex align-items-center">
            {/* Globe Icon (Blue) */}
            <i className="bi bi-globe me-2" style={{ color: "#0dcaf0" }}></i>
            Visit: pro.madhiacademy.com
          </li>
        </ul>
      ),
    }
  ];

  return (
    <section className="faq-section py-5">
      <div className="container ml-5 mr-5">
        
        {/* Title Section with Purple Bar */}
        <div className="d-flex align-items-center mb-5" style={{ marginLeft: "0" }}> 
          {/* Removed huge left margin to align standardly, or keep '8%' if desired */}
          <div className="title-bar me-3"></div>
          <h2 className="fw-bold text-dark m-0">Frequently Asked Questions</h2>
        </div>

        {/* FAQ List */}
        <div className="row">
          <div className="col-12">
            {faqData.map((item) => (
              <div
                key={item.id}
                className={`faq-item mb-3 ${activeId === item.id ? "active" : ""}`}
                onClick={() => toggleFAQ(item.id)}
              >
                {/* Question Header */}
                <div className="faq-header d-flex justify-content-between align-items-center p-3 cursor-pointer">
                  <h6
                    className={`m-0 fw-semibold ${
                      activeId === item.id ? "text-purple" : "text-dark"
                    }`}
                  >
                    {item.question}
                  </h6>
                  {/* Icon switches between Up and Down chevron */}
                  <i
                    className={`bi bi-chevron-${activeId === item.id ? "up" : "down"} transition-icon ${
                      activeId === item.id ? "text-purple" : ""
                    }`}
                  ></i>
                </div>

                {/* Answer Body (Collapsible) */}
                <div className={`faq-body ${activeId === item.id ? "show" : ""}`}>
                  <div className="p-3 pt-0 text-muted small lh-lg">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;